import { useNotificationsStore } from "@/store/notifications.js";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed.js";
import { t } from "@/controllerLK/AvalLocalization";

export default function errorInterceptor(axios) {
    const notificationStore = useNotificationsStore();
    axios.interceptors.request.use(function (request) {
        return request;
    }, function (error) {
        return Promise.reject(error);
    });

    axios.interceptors.response.use(function (response) {
        if ((
            (response.response && response.response.status >= 400 && response.response.status < 500)
            || response.status >= 400 && response.status < 500)
            && (response.response && response.response.status !== 401
            )) {
            notificationStore.createNotify(t("interceptor.error.bad_request"), "error");
            useNewsFeedStore().loading = false;
        }
        if ((response.response && response.response.status >= 500 && response.response.status < 600)
            || response.status >= 500 && response.status < 600) {
            notificationStore.createNotify(t("interceptor.error.server_error"), "error");
            useNewsFeedStore().loading = false;
        }
        return response;
    }, function (error) {

        if (error.response.status >= 400 && error.response.status <= 500) {
            notificationStore.createNotify(t("interceptor.error.bad_request"), "error");
        }

        if (error.response.status >= 500 && error.response.status <= 600) {
            notificationStore.createNotify(t("interceptor.error.server_error"), "error");
        }

        useNewsFeedStore().loading = false;

        return Promise.reject(error);
    });
}